export const checkinmanual = {
    text1: "Check-in manuel",
    text2: "Saisissez les données requises pour l'enregistrement du client.",
    text3: "Informations sur l'hébergement",
    text4: "Sélectionnez l'hébergement *",
    text5: "Informations personnelles",
    text6: "Prénom du client *",
    text7: "Nom du client *",
    text8: "Homme",
    text9: "Femme",
    text10: "Préfère ne pas répondre",
    text11: "Autre",
    text12: "Sélectionnez le sexe *",
    text13: "Date de naissance *",
    text14: "Numéro de téléphone *",
    text15: "Informations sur le séjour",
    text16: "Les informations sur le séjour sont obligatoires pour poursuivre le check-in. Veuillez remplir tous les champs.",
    text17: "Du - Au",
    text18: "Jusqu'à quelle date le client séjournera-t-il ?",
    text19: "E-mail du client *",
    text20: "Sélectionnez le type de document.",
    text21: "Carte d'identité",
    text22: "Passeport",
    text23: "Type de document",
    text24: "Numéro de document",
    text25: "Saisissez le numéro de document",
    text26: "Expiration du document",
    text27: "Expiration du document",
    text28: "Continuer",
    text29: "Check-in manuel",
    text30: "Saisissez les données requises pour l'enregistrement du client.",
    text31: "Signature du check-in",
    text32: "Signez dans la zone grise que vous voyez à l'écran",
    text33: "Enregistrer le check-in",
    text34: "Processus de check-in terminé avec succès.",
    text35: "Vous devez sélectionner un hébergement pour attribuer le check-in",
    text36: "Le champ du prénom est requis",
    text37: "Le champ du nom est requis",
    text38: "Le champ du sexe est requis",
    text39: "Le champ de la date de naissance est requis",
    text40: "Le champ du téléphone est requis",
    text41: "Le champ de la date de séjour est requis",
    text42: "Le champ de l'e-mail est requis",
    text43: "Le champ du pays est requis",
    text44: "Le champ du type de document est requis",
    text45: "Le champ du numéro de document est requis",
    text46: "Vous devez accepter les conditions générales.",
    text47: "Envoi des données de check-in, veuillez patienter...",
    text48: "Chargement...",
    text49: "a effectué le check-in avec succès.",
    text50: "Cliquez ici pour voir tous nos services disponibles à l'hôtel",
    text51: "Saisissez le prénom",
    text52: "Saisissez le nom",
    text53: "Pays",
    text54: "Erreur",
    text55: "Saisissez l'adresse e-mail",

    // Corrections
    p1: "Date de check-in",
    p2: "Date de check-out",
    p3: "Date de délivrance du document",
    p4: "",
    p5: "",
    p6: "",
    p7: "",
    p8: "",
};
